import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, CSSResult } from 'lit'

import { csColorAction, csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const cscBlogPost = {
  
  borderColor: css`var(--csc-blog-post-border-color, ${csColorBorder.light})`,
  borderColorHover: css`var(--csc-blog-post-border-color-hover, ${csColorBorder.light})`,
  borderPosition: css`var(--csc-blog-post-border-position, 0 0 1px 0)`,
  rowGap: css`var(--csc-blog-post-row-gap, ${csSpacing.spacing06})`,
  bodyPaddingBlock: css`var(--csc-blog-post-body-padding-y, ${csSpacing.spacing05})`,
  bodyPaddingInline: css`var(--csc-blog-post-body-padding-x, ${csSpacing.spacing05})`,
  backgroundColorHover: css`var(--csc-blog-post-background-color-hover, ${csColorBorder.light})`,
  boxShadowHover: css`var(--csc-blog-post-box-shadow-hover, none)`,
}

export const style: CSSResult = css`
  .content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${cscBlogPost.rowGap};
    align-self: stretch;
  }

  cse-card {
    --cse-card-border-width: ${cscBlogPost.borderPosition};
    --cse-card-border-color: ${cscBlogPost.borderColor};
    --cse-card-border-color-hover: ${cscBlogPost.borderColorHover};
    --cse-card-background-color-hover: ${cscBlogPost.backgroundColorHover};
    --cse-card-box-shadow-hover: ${cscBlogPost.boxShadowHover};
    --cse-card-gap: 0;
  }
  cse-card[variant="inline"] {
    --cse-card-body-padding-y: ${cscBlogPost.bodyPaddingBlock};
    --cse-card-body-padding-x: ${cscBlogPost.bodyPaddingInline};
    
  }

  cse-list {
    --cse-list-bullet-color: ${csColorAction.primary};
  }
`
